import React from "react";
import { FaTwitter, FaFacebook, FaLinkedin, FaGithub } from "react-icons/fa";
import "./Footer.css";

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="footer-section" role="contentinfo">
      {/* Top row: copyright + nav links */}
      <div className="footer-top">
        <span className="footer-copy">
          &copy; {year} Jangcoin. All rights reserved.
        </span>

        <nav className="footer-links" aria-label="Footer navigation">
          <a href="/privacy" className="footer-link">Privacy Policy</a>
          <a href="/terms" className="footer-link">Terms of Use</a>
          <a href="/about" className="footer-link">About</a>
          <a href="/contact" className="footer-link">Contact</a>
        </nav>
      </div>

      {/* Social icons row (SVG via react-icons). 
          CSS below guarantees no stray text like "??" is visible. */}
      <div className="footer-socials" aria-label="Social links">
        <a
          href="https://twitter.com/yourhandle"
          className="footer-social"
          aria-label="Twitter"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FaTwitter aria-hidden="true" focusable="false" />
        </a>

        <a
          href="https://facebook.com/yourpage"
          className="footer-social"
          aria-label="Facebook"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FaFacebook aria-hidden="true" focusable="false" />
        </a>

        <a
          href="https://www.linkedin.com/company/yourcompany"
          className="footer-social"
          aria-label="LinkedIn"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FaLinkedin aria-hidden="true" focusable="false" />
        </a>

        <a
          href="https://github.com/fonchrist"
          className="footer-social"
          aria-label="GitHub"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FaGithub aria-hidden="true" focusable="false" />
        </a>
      </div>

      {/* Disclaimer row */}
      <div className="footer-disclaimer">
        Disclaimer: Jangcoin is an educational and community platform, not an
        investment or financial service.
      </div>
    </footer>
  );
}